// AI Consulting Services content
export const aiServices = [
  {
    id: 'strategy',
    title: 'AI Strategy & Roadmap',
    icon: 'Compass',
    tagline: 'A practical AI strategy aligned with business goals.',
    features: [
      'AI maturity assessment',
      'AI opportunity discovery',
      'Business use-case identification',
      'AI transformation roadmap',
      'ROI analysis',
      'Executive workshops'
    ]
  },
  {
    id: 'genai',
    title: 'Generative AI Consulting',
    icon: 'Sparkles',
    tagline: 'Harness LLMs for productivity, engagement, and decisions.',
    features: [
      'ChatGPT integration',
      'Microsoft Copilot adoption',
      'Amazon Bedrock solutions',
      'AI-powered assistants',
      'Enterprise knowledge assistants',
      'Intelligent document processing',
      'AI search solutions',
      'Custom AI copilots'
    ]
  },
  {
    id: 'solution-design',
    title: 'AI Solution Design',
    icon: 'Layers',
    tagline: 'AI architectures that integrate seamlessly with your stack.',
    features: [
      'Solution architecture',
      'AI model selection',
      'Secure AI workflows',
      'Scalable AI platforms',
      'Governance & compliance'
    ]
  },
  {
    id: 'ml',
    title: 'Machine Learning Consulting',
    icon: 'Brain',
    tagline: 'Transform data into actionable intelligence.',
    features: [
      'Predictive analytics',
      'Demand forecasting',
      'Customer segmentation',
      'Recommendation engines',
      'Fraud detection',
      'Anomaly detection',
      'Intelligent automation'
    ]
  },
  {
    id: 'automation',
    title: 'AI-Powered Business Automation',
    icon: 'Workflow',
    tagline: 'Reduce manual effort. Ship faster with intelligent workflows.',
    features: [
      'Intelligent workflows',
      'AI document extraction',
      'Invoice processing',
      'Email automation',
      'Customer support automation',
      'Workflow optimization'
    ]
  },
  {
    id: 'governance',
    title: 'Responsible AI & Governance',
    icon: 'ShieldCheck',
    tagline: 'Secure, transparent, and compliant AI — by design.',
    features: [
      'AI security assessments',
      'Model governance',
      'Risk management',
      'Ethical AI frameworks',
      'Compliance guidance',
      'Data privacy best practices'
    ]
  }
];

export const industries = [
  { name: 'Retail & FMCG', icon: 'ShoppingBag' },
  { name: 'Real Estate & Construction', icon: 'Building2' },
  { name: 'Financial Services', icon: 'Landmark' },
  { name: 'Healthcare', icon: 'HeartPulse' },
  { name: 'Manufacturing', icon: 'Factory' },
  { name: 'Logistics & Supply Chain', icon: 'Truck' },
  { name: 'Hospitality', icon: 'Hotel' },
  { name: 'Government', icon: 'Landmark' },
  { name: 'Education', icon: 'GraduationCap' },
  { name: 'Media & Entertainment', icon: 'Film' }
];

export const approach = [
  { step: '01', title: 'Discover', description: 'We understand your business, challenges, and strategic objectives.' },
  { step: '02', title: 'Assess', description: 'We evaluate your existing data, applications, cloud environment, and AI readiness.' },
  { step: '03', title: 'Design', description: 'We create a tailored AI roadmap focused on quick wins and long-term transformation.' },
  { step: '04', title: 'Build', description: 'We implement scalable AI solutions using industry-leading platforms and best practices.' },
  { step: '05', title: 'Optimize', description: 'We continuously monitor, improve, and scale AI solutions to maximize business value.' }
];

export const whyChoose = [
  { title: 'Business-First Approach', description: 'We focus on solving business challenges — not simply deploying technology.', icon: 'Target' },
  { title: 'Cloud & AI Expertise', description: 'Deep expertise in cloud platforms to build scalable, secure, enterprise-ready AI.', icon: 'Cloud' },
  { title: 'End-to-End Consulting', description: 'Strategy → architecture → deployment → optimization. We support your entire journey.', icon: 'GitBranch' },
  { title: 'Practical AI Adoption', description: 'Measurable ROI, rapid implementation, and sustainable business value.', icon: 'TrendingUp' },
  { title: 'Security & Governance', description: 'Enterprise-grade security, compliance, and responsible AI principles at the core.', icon: 'Lock' }
];

export const technologies = [
  'OpenAI', 'Amazon Bedrock', 'AWS AI/ML', 'Microsoft Azure AI', 'Google Cloud AI',
  'Anthropic Claude', 'Meta Llama', 'Python', 'LangChain', 'Vector Databases',
  'RAG', 'AI Agents', 'Multi-Agent Systems'
];

export const consultingFaqs = [
  { q: 'How do I know if my business is ready for AI?', a: 'Our AI Readiness Assessment evaluates your data, technology landscape, business processes, and strategic objectives to identify the best opportunities for AI adoption.' },
  { q: 'How long does an AI consulting engagement take?', a: 'Depending on the scope, engagements can range from a two-week assessment to a multi-month enterprise transformation program.' },
  { q: 'Can AI integrate with our existing systems?', a: 'Yes. We design AI solutions that integrate with your existing ERP, CRM, cloud platforms, databases, and business applications.' },
  { q: 'Is AI secure for enterprise use?', a: 'Yes. We implement enterprise-grade security, access controls, governance, and compliance practices to ensure your AI solutions are secure and trustworthy.' }
];
